class StepModal {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 4;
    this.selections = {};
    this.isOpen = false;

    // 从全局配置读取步骤数据，如果没有配置则使用默认值
    this.steps = this.getStepsConfig();
    this.recommendationConfig = this.getRecommendationConfig();

    this.init();
  }

  getStepsConfig() {
    // 从data属性读取配置
    const container = document.getElementById('step-modal-container');
    if (container) {
      const dataset = container.dataset;

      // 构建步骤配置
      const steps = {};
      for (let i = 1; i <= 4; i++) {
        const stepKey = `step${i}`;
        steps[i] = {
          title: dataset[`${stepKey}Title`] || `Step ${i}`,
          options: []
        };

        // 构建选项配置
        for (let j = 1; j <= 4; j++) {
          // 正确的属性名应该是 step1Option1Label, step1Option1Tag, step1Option1Image
          const labelKey = `step${i}Option${j}Label`;
          const tagKey = `step${i}Option${j}Tag`;
          const imageKey = `step${i}Option${j}Image`;

          const label = dataset[labelKey];
          const tag = dataset[tagKey];
          const image = dataset[imageKey];


          // 只有当标签不为空时才显示该选项
          if (label && label.trim() !== '') {
            steps[i].options.push({
              id: `option${j}`,
              label: label,
              tag: tag || 'A',
              image: image || this.getDefaultImage()
            });
          }
        }
      }

      return steps;
    }

    // 默认配置作为后备
    return this.getDefaultStepsConfig();
  }

  getRecommendationConfig() {
    // 从data属性读取配置
    const container = document.getElementById('step-modal-container');
    if (container) {
      const dataset = container.dataset;

      const featuresProduct1 = [
        dataset['product1Feature1'],
        dataset['product1Feature2'],
        dataset['product1Feature3'],
        dataset['product1Feature4'],
        dataset['product1Feature5']
      ].filter(f => f && f.trim());

      const featuresProduct2 = [
        dataset['product2Feature1'],
        dataset['product2Feature2'],
        dataset['product2Feature3'],
        dataset['product2Feature4'],
        dataset['product2Feature5']
      ].filter(f => f && f.trim());

      console.log('Raw Product 2 Features from dataset:', {
        feature1: dataset['product2Feature1'],
        feature2: dataset['product2Feature2'],
        feature3: dataset['product2Feature3'],
        feature4: dataset['product2Feature4'],
        feature5: dataset['product2Feature5']
      });
      console.log('Filtered Product 2 Features:', featuresProduct2);

      return {
        featuresProduct1: featuresProduct1,
        featuresProduct2: featuresProduct2,
        products: {
          1: {
            id: dataset.product1Id || "",
            name: dataset.product1Name || "",
            description: dataset.product1Description || "",
            price: dataset.product1Price || "",
            originalPrice: dataset.product1OriginalPrice || "",
            background: dataset.product1Background || "",
            backgroundMb: dataset.product1BackgroundMb || "",
            link: dataset.product1Link || "/products/yarbo-m1"
          },
          2: {
            id: dataset.product2Id || "",
            name: dataset.product2Name || "",
            description: dataset.product2Description || "",
            price: dataset.product2Price || "",
            originalPrice: dataset.product2OriginalPrice || "",
            background: dataset.product2Background || "",
            backgroundMb: dataset.product2BackgroundMb || "",
            link: dataset.product2Link || "/products/yarbo-m1-pro"
          }
        },
        ctaText: dataset.ctaButtonText || "Learn More",
      };
    }

    // 默认配置作为后备
    return this.getDefaultRecommendationConfig();
  }

  getDefaultStepsConfig() {
    return {
      1: {
        title: "Step 1",
        options: []
      },
      2: {
        title: "Step 2",
        options: []
      },
      3: {
        title: "Step 3",
        options: []
      },
      4: {
        title: "Step 4",
        options: []
      }
    };
  }

  getDefaultRecommendationConfig() {
    return {
      featuresProduct1: [],
      featuresProduct2: [],
      products: {
        1: {
          id: "",
          name: "YARBO M1",
          description: "YARBO M1 智能割草机器人，适合家庭使用。",
          price: "",
          image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=400&fit=crop",
          background: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=800&h=400&fit=crop",
          link: "/products/yarbo-m1"
        },
        2: {
          id: "",
          name: "YARBO M1 Pro",
          description: "YARBO M1 Pro 专业级智能割草机器人，更强性能和功能。",
          price: "",
          image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=400&fit=crop",
          background: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=800&h=400&fit=crop",
          link: "/products/yarbo-m1-pro"
        }
      },
      ctaText: "立即购买"
    };
  }

  getDefaultImage() {
    return "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop";
  }

  init() {
    this.createModal();
    this.bindEvents();
    this.bindResizeEvents();
  }

  bindResizeEvents() {
    // 添加防抖功能，避免频繁渲染
    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        if (this.isOpen && this.currentStep > this.totalSteps) {
          // 只有当弹窗打开且处于推荐页面时才重新渲染
          console.log('Window resized, re-rendering recommendation');
          this.renderRecommendation();
        }
      }, 250); // 250ms防抖
    });
  }

  isMobile() {
    // 检测是否为移动设备
    return window.innerWidth <= 768;
  }

  createModal() {
    // 创建弹窗HTML结构
    const modalHTML = `
    <div class="modal-overlay" id="stepModal">
      <div class="step-modal">
        <div class="modal-header">
          <div class="step-indicator">
            <span id="currentStepNum">1</span>/${this.totalSteps}
          </div>
          <button class="close-btn" id="closeModal">×</button>
        </div>
        <div class="modal-content" id="modalContent">
          <!-- 动态内容将在这里插入 -->
        </div>
      </div>
    </div>
  `;

    // 将弹窗添加到页面
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    this.modal = document.getElementById('stepModal');
    this.modalContent = document.getElementById('modalContent');
    this.stepIndicator = document.getElementById('currentStepNum');
    this.stepIndicatorContainer = document.querySelector('.step-indicator');
  }

  bindEvents() {
    // 关闭按钮事件
    document.getElementById('closeModal').addEventListener('click', () => {
      this.closeModal();
    });

    // 点击遮罩层关闭
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // ESC键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.resetModal();
    this.modal.classList.add('active');
    this.isOpen = true;
    // 不禁用body滚动，保持页面可滚动
    this.renderStep();
  }

  closeModal() {
    this.modal.classList.remove('active');
    this.isOpen = false;
    // 不需要修改body滚动，保持原样
  }

  resetModal() {
    this.currentStep = 1;
    this.selections = {};
    // 移除推荐模式的CSS类
    this.modal.classList.remove('recommendation-mode');

    // 清理Results标题
    const modalHeader = this.modal.querySelector('.modal-header');
    const resultsTitle = modalHeader.querySelector('.results-title');
    if (resultsTitle) {
      resultsTitle.remove();
    }

    // 恢复正常的步骤指示器格式
    this.stepIndicatorContainer.innerHTML = `<span id="currentStepNum">1</span>/${this.totalSteps}`;
    this.stepIndicator = document.getElementById('currentStepNum');
  }

  renderStep() {
    if (this.currentStep > this.totalSteps) {
      this.renderRecommendation();
      return;
    }

    const step = this.steps[this.currentStep];
    const isSelected = this.selections[this.currentStep];
    const isMultiSelect = false; // 所有步骤都是单选

    const stepHTML = `
    <h2 class="step-title">${step.title}</h2>
    ${isMultiSelect ? '<p class="step-subtitle">You can select multiple options</p>' : ''}
    <div class="options-grid ${isMultiSelect ? 'multi-select' : ''}">
      ${step.options.map(option => `
        <div class="option-card" data-option="${option.id}">
          <img src="${option.image}" alt="${option.label}" class="option-image">
          <div class="option-label">${option.label}</div>
        </div>
      `).join('')}
    </div>
    <button class="next-btn ${isSelected ? 'active' : ''}" id="nextBtn">
      Next
    </button>
  `;

    this.modalContent.innerHTML = stepHTML;
    this.stepIndicator.textContent = this.currentStep;

    // 动态设置网格列数
    const optionsGrid = this.modalContent.querySelector('.options-grid');
    const optionCount = step.options.length;

    // 特殊处理三个选项的情况：使用两行布局，第二行居中
    if (optionCount === 3) {
      optionsGrid.className = `options-grid cols-2 three-options`;
    } else {
      optionsGrid.className = `options-grid cols-${optionCount}`;
    }

    // 绑定选项点击事件
    this.bindOptionEvents();

    // 绑定下一步按钮事件
    document.getElementById('nextBtn').addEventListener('click', () => {
      if (this.selections[this.currentStep]) {
        this.nextStep();
      }
    });

    // 如果已有选择，显示选中状态
    if (isSelected) {
      if (isMultiSelect && Array.isArray(isSelected)) {
        // 多选：恢复多个选中状态
        isSelected.forEach(optionId => {
          const selectedCard = this.modalContent.querySelector(`[data-option="${optionId}"]`);
          if (selectedCard) {
            selectedCard.classList.add('selected');
          }
        });
      } else if (!isMultiSelect) {
        // 单选：恢复单个选中状态
        const selectedCard = this.modalContent.querySelector(`[data-option="${isSelected}"]`);
        if (selectedCard) {
          selectedCard.classList.add('selected');
        }
      }
    }
  }

  bindOptionEvents() {
    const optionCards = this.modalContent.querySelectorAll('.option-card');
    const nextBtn = document.getElementById('nextBtn');
    const isMultiSelect = false; // 所有步骤都是单选

    optionCards.forEach(card => {
      // 添加点击事件
      card.addEventListener('click', () => {
        if (isMultiSelect) {
          this.selectMultiOption(card, optionCards, nextBtn);
        } else {
          this.selectSingleOption(card, optionCards, nextBtn);
        }
      });

      // 添加键盘支持
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (isMultiSelect) {
            this.selectMultiOption(card, optionCards, nextBtn);
          } else {
            this.selectSingleOption(card, optionCards, nextBtn);
          }
        }
      });

      // 添加焦点支持
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', isMultiSelect ? 'checkbox' : 'radio');
      card.setAttribute('aria-pressed', 'false');
    });
  }

  selectSingleOption(selectedCard, allCards, nextBtn) {
    // 添加选择动画
    selectedCard.style.transform = 'scale(0.98)';

    setTimeout(() => {
      // 移除其他选中状态
      allCards.forEach(c => {
        c.classList.remove('selected');
        c.setAttribute('aria-pressed', 'false');
      });

      // 添加当前选中状态
      selectedCard.classList.add('selected');
      selectedCard.setAttribute('aria-pressed', 'true');
      selectedCard.style.transform = '';

      // 保存选择
      const optionId = selectedCard.dataset.option;
      this.selections[this.currentStep] = optionId;

      // 激活下一步按钮并添加动画
      nextBtn.classList.add('active');
      nextBtn.style.transform = 'scale(1.05)';

      setTimeout(() => {
        nextBtn.style.transform = '';
      }, 150);

    }, 100);
  }

  selectMultiOption(selectedCard, allCards, nextBtn) {
    // 添加选择动画
    selectedCard.style.transform = 'scale(0.98)';

    setTimeout(() => {
      const optionId = selectedCard.dataset.option;

      // 初始化多选数组
      if (!this.selections[this.currentStep]) {
        this.selections[this.currentStep] = [];
      }

      // 切换选中状态
      if (selectedCard.classList.contains('selected')) {
        // 取消选择
        selectedCard.classList.remove('selected');
        selectedCard.setAttribute('aria-pressed', 'false');
        this.selections[this.currentStep] = this.selections[this.currentStep].filter(id => id !== optionId);
      } else {
        // 添加选择
        selectedCard.classList.add('selected');
        selectedCard.setAttribute('aria-pressed', 'true');
        this.selections[this.currentStep].push(optionId);
      }

      selectedCard.style.transform = '';

      // 检查是否有选择，激活下一步按钮
      if (this.selections[this.currentStep] && this.selections[this.currentStep].length > 0) {
        nextBtn.classList.add('active');
        nextBtn.style.transform = 'scale(1.05)';
        setTimeout(() => {
          nextBtn.style.transform = '';
        }, 150);
      } else {
        nextBtn.classList.remove('active');
      }

    }, 100);
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.renderStep();
    } else {
      // 完成所有步骤，显示推荐页面
      this.renderRecommendation();
    }
  }

  renderRecommendation() {
    const recommendation = this.getRecommendation();

    console.log('Recommended product:', {
      id: recommendation.id,
      firstVariantId: recommendation.firstVariantId,
      name: recommendation.name,
      description: recommendation.description
    });

    // 根据屏幕尺寸选择背景图或顶部图片
    const isMobile = this.isMobile();
    const image = isMobile ?
      (recommendation.backgroundMb || recommendation.background) :
      recommendation.background;

    // 桌面端使用背景图，移动端不使用背景
    const backgroundStyle = !isMobile && image ?
      `background-image: url('${image}'); background-size: cover; background-position: center; background-repeat: no-repeat;` :
      (!isMobile ? 'background: linear-gradient(135deg, #4a7c59 0%, #6b8e5a 100%);' : '');

    console.log('Rendering for:', isMobile ? 'Mobile' : 'Desktop');

    const recommendationHTML = `
    <div class="recommendation-content" style="${backgroundStyle}" data-view-mode="${isMobile ? 'mobile' : 'desktop'}">
      ${isMobile && image ? `<div class="product-image-container">
        <img src="${image}" alt="${recommendation.name}" class="product-image">
      </div>` : ''}
      <div class="product-recommendation">
        <div class="product-info">
          <h3 class="product-name">${recommendation.name}</h3>
          ${recommendation.description ? `<p class="product-description">${recommendation.description}</p>` : ''}
          ${this.generateFeaturesList() ? `
          <div class="product-features">
            <h4 class="features-title">Why it's suited to you:</h4>
            <div class="features-list">
              ${this.generateFeaturesList()}
            </div>
          </div>
          ` : ''}
          
          ${recommendation.price || recommendation.originalPrice ? `
          <div class="product-price">
            ${recommendation.price ? `<span class="current-price">${recommendation.price}</span>` : ''}
            ${recommendation.originalPrice ? `<span class="original-price">${recommendation.originalPrice}</span>` : ''}
          </div>
          ` : ''}
          
          <div class="recommendation-buttons">
            <button class="cta-button primary" onclick="window.location.href='${recommendation.link}${recommendation.link.includes('?') ? '&' : '?'}p=fi'">
              ${recommendation.ctaText || 'Learn More'}
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

    this.modalContent.innerHTML = recommendationHTML;

    // 添加推荐模式的CSS类，移除padding
    this.modal.classList.add('recommendation-mode');
    console.log('Added recommendation-mode class:', this.modal.classList.contains('recommendation-mode'));

    // 将 "Restart" 放到左上角步骤指示器位置
    this.stepIndicatorContainer.innerHTML = '<span id="restartBtn" style="cursor: pointer; color: #007bff; font-weight: 500;">Restart</span>';

    // 在弹窗头部中间添加 "Results" 标题
    const modalHeader = this.modal.querySelector('.modal-header');
    let resultsTitle = modalHeader.querySelector('.results-title');
    if (!resultsTitle) {
      resultsTitle = document.createElement('div');
      resultsTitle.className = 'results-title';
      resultsTitle.textContent = 'Results';
      resultsTitle.style.cssText = 'position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600; color: #333;';
      modalHeader.appendChild(resultsTitle);
    }

    // 绑定Restart按钮的点击事件
    const restartBtn = document.getElementById('restartBtn');
    if (restartBtn) {
      restartBtn.onclick = () => {
        this.resetModal();
        this.renderStep();
      };
    }
  }


  generateFeaturesList() {
    // 根据当前推荐的产品选择对应的特性列表
    const productId = this.calculateRecommendedProductByTags(this.getSelectedTags());

    let features;
    if (productId === 1) {
      features = this.recommendationConfig.featuresProduct1 || [];
    } else {
      features = this.recommendationConfig.featuresProduct2 || [];
    }

    console.log('Product ID:', productId);
    console.log('Features Product1:', this.recommendationConfig.featuresProduct1);
    console.log('Features Product2:', this.recommendationConfig.featuresProduct2);
    console.log('Selected features:', features);

    // 如果没有配置任何特性，返回空字符串
    if (features.length === 0) {
      console.log('No features configured, returning empty string');
      return '';
    }

    const featuresHTML = features.map(feature => `
      <div class="feature-item">
        <div class="feature-icon"></div>
        <div class="feature-text">${feature}</div>
      </div>
    `).join('');

    console.log('Generated features HTML:', featuresHTML);
    return featuresHTML;
  }

  getRecommendation() {
    // 根据用户选择返回推荐产品
    const selectedTags = this.getSelectedTags();

    // 使用标记组合进行推荐
    const productId = this.calculateRecommendedProductByTags(selectedTags);
    const product = this.recommendationConfig.products[productId];

    return {
      id: product.id,
      name: product.name,
      description: product.description,
      price: product.price,
      originalPrice: product.originalPrice,
      image: product.image || this.getDefaultImage(),
      background: product.background,
      backgroundMb: product.backgroundMb,
      link: product.link,
      ctaText: this.recommendationConfig.ctaText
    };
  }

  getSelectedTags() {
    const tags = [];

    for (let step = 1; step <= 4; step++) {
      const selectedOption = this.selections[step];

      if (selectedOption && this.steps[step] && this.steps[step].options) {
        // 所有步骤都是单选
        const option = this.steps[step].options.find(opt => opt.id === selectedOption);
        if (option && option.tag) {
          tags.push(option.tag);
        }
      }
    }

    return tags;
  }

  calculateRecommendedProductByTags(selectedTags) {
    // 新的简单逻辑：统计B标记的数量
    const bCount = selectedTags.filter(tag => tag === 'B').length;

    // 2个或以上B推荐产品2，否则推荐产品1
    const recommendedProduct = bCount >= 2 ? 2 : 1;
    console.log('Selected Tags:', selectedTags);
    console.log('B Count:', bCount);
    console.log('Recommended Product:', recommendedProduct);
    return recommendedProduct;
  }

  calculateBestMatchByTags(selectedTags) {
    let bestMatch = 1;
    let maxScore = 0;

    for (let productId = 1; productId <= 2; productId++) {
      const combinations = this.recommendationConfig.tagCombinations[productId];
      if (combinations) {
        const combinationList = combinations.split('|');
        let productScore = 0;

        // 计算与每个组合的匹配度
        combinationList.forEach(combination => {
          const tags = combination.split(',');
          let matchCount = 0;

          tags.forEach(tag => {
            if (selectedTags.includes(tag)) {
              matchCount++;
            }
          });

          // 计算匹配百分比
          const score = matchCount / tags.length;
          productScore = Math.max(productScore, score);
        });

        if (productScore > maxScore) {
          maxScore = productScore;
          bestMatch = productId;
        }
      }
    }

    return bestMatch;
  }

  calculateRecommendedProduct(terrain, size, grass, frequency) {
    // 推荐算法：根据选择组合计算最适合的产品
    let score = {
      1: 0, // Basic
      2: 0, // Professional  
      3: 0, // Premium
      4: 0  // Commercial
    };

    // 根据地形评分
    switch (terrain) {
      case 'option1': // Flat and even
        score[1] += 3; score[2] += 2; score[3] += 1; score[4] += 0;
        break;
      case 'option2': // Hilly or sloped
        score[1] += 1; score[2] += 3; score[3] += 2; score[4] += 1;
        break;
      case 'option3': // Rugged/Tough Terrain
        score[1] += 0; score[2] += 1; score[3] += 3; score[4] += 2;
        break;
      case 'option4': // Complex with obstacles
        score[1] += 0; score[2] += 0; score[3] += 2; score[4] += 3;
        break;
    }

    // 根据院子大小评分
    switch (size) {
      case 'option1': // Small
        score[1] += 3; score[2] += 2; score[3] += 0; score[4] += 0;
        break;
      case 'option2': // Medium
        score[1] += 2; score[2] += 3; score[3] += 2; score[4] += 0;
        break;
      case 'option3': // Large
        score[1] += 0; score[2] += 2; score[3] += 3; score[4] += 2;
        break;
      case 'option4': // Extra Large
        score[1] += 0; score[2] += 0; score[3] += 2; score[4] += 3;
        break;
    }

    // 根据草坪类型评分（某些草坪需要更频繁或专业的护理）
    switch (grass) {
      case 'option1': // Bermuda Grass
        score[1] += 2; score[2] += 3; score[3] += 2; score[4] += 1;
        break;
      case 'option2': // Zoysia Grass
        score[1] += 3; score[2] += 2; score[3] += 1; score[4] += 1;
        break;
      case 'option3': // Fescue Grass
        score[1] += 2; score[2] += 2; score[3] += 3; score[4] += 2;
        break;
      case 'option4': // Mixed/Other
        score[1] += 1; score[2] += 2; score[3] += 2; score[4] += 3;
        break;
    }

    // 根据割草频率评分
    switch (frequency) {
      case 'option1': // Daily
        score[1] += 0; score[2] += 1; score[3] += 2; score[4] += 3;
        break;
      case 'option2': // Weekly
        score[1] += 2; score[2] += 3; score[3] += 2; score[4] += 1;
        break;
      case 'option3': // Bi-weekly
        score[1] += 3; score[2] += 2; score[3] += 1; score[4] += 0;
        break;
      case 'option4': // Monthly
        score[1] += 3; score[2] += 1; score[3] += 0; score[4] += 0;
        break;
    }

    // 找到得分最高的产品
    let recommendedProduct = 1;
    let maxScore = score[1];

    for (let i = 2; i <= 4; i++) {
      if (score[i] > maxScore) {
        maxScore = score[i];
        recommendedProduct = i;
      }
    }

    return recommendedProduct;
  }
}

// 创建全局实例
let stepModalInstance;

function initStepModal() {
  const configContainer = document.getElementById('step-modal-container');
  if (configContainer) {
    stepModalInstance = new StepModal();
  }
  bindClassTriggers();
}

// defer 脚本执行时 DOM 通常已就绪，兼容两种情况
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStepModal);
} else {
  initStepModal();
}

// 绑定class触发器函数
function bindClassTriggers() {
  // 为所有带有 'open-step-modal' class的元素绑定点击事件
  const triggers = document.querySelectorAll('.open-step-modal');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault(); // 防止默认行为（如链接跳转）
      openStepModal();
    });
  });

  // 监听动态添加的元素（使用事件委托）
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('open-step-modal')) {
      e.preventDefault();
      openStepModal();
    }
  });
}

// 全局函数供任何地方调用
window.openStepModal = function () {
  // 如果实例不存在，先创建
  if (!stepModalInstance) {
    const configContainer = document.getElementById('step-modal-container');
    if (configContainer) {
      stepModalInstance = new StepModal();
    } else {
      console.error('Step modal configuration not found. Please make sure the Future Included section is added to your theme.');
      return;
    }
  }

  if (stepModalInstance) {
    stepModalInstance.openModal();
  }
};

// 全局函数供关闭弹窗
window.closeStepModal = function () {
  if (stepModalInstance) {
    stepModalInstance.closeModal();
  }
};

// 全局函数获取当前选择状态
window.getStepModalSelections = function () {
  if (stepModalInstance) {
    return stepModalInstance.selections;
  }
  return {};
};
